export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12099.9c5bff26.jpg";